import { ApiError, ApiParameter, get, rawRequest, request } from "@insite/client-framework/Services/ApiService";
import { AutocompleteApiParameter } from "@insite/client-framework/Services/AutocompleteService";


export interface SearchItemParameter extends AutocompleteApiParameter {
    categoryId?: string
}

export const SearchItemUrl = "api/v2/searchproduct"

export async function GetSearchItems(params: SearchItemParameter) {
    const response = await fetch(`${SearchItemUrl}`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(params)
    });

    try {
        const result = response.ok && (await response.json())
        if (!response.ok) {
            throw new Error(
                JSON.stringify({
                    status: response.status,
                    errorJson: {
                        message: response.statusText,
                    },
                }),
            );
        }
        return result;
    } catch (error) {
        let message: string;
        let errorJson: any;
        if (response.headers.get("Content-Type")?.startsWith("application/json")) {
            errorJson = (await response.json()) as { message: string; exceptionMessage?: string };
            message = errorJson.exceptionMessage ?? errorJson.message;
        } else {
            message = await response.text();
        }
        throw new ApiError(SearchItemUrl, response, message, errorJson);
    }

}